// extracted by mini-css-extract-plugin
export default {"row":"CKMK5gssnVg4XSiuC8bg","col":"KSA1hHqqZ0MnYcHF3U0T","fadeIn":"fihAchjtoWUBq0BmjemZ"};